import React from 'react';
import './MainContent.css';

const MainContent = () => {
  return (
    <div className='main-content'>
      <div className='text-content'>
        <h1>REDEFINE REALITY.</h1>
        <p>Shatter the Simulation, Reclaim Reality</p>
        
      </div>
      <div className='image-content'>
        <img src='/images/STBRAINT.png' alt='STBRAINT' />
      </div>
    </div>
  );
};

export default MainContent;
